import { Component, OnInit } from '@angular/core';
import { NbDialogRef, NbCardModule, NbIconModule, NbButtonModule } from '@nebular/theme';
import { UtilityService } from 'src/app/core/services/utility.service';
import { SourceItem } from 'src/app/models/drb-models/source-item';
import { DRBTYPE } from 'src/app/shared/constants/general-constants';

@Component({
    selector: 'app-view-source-item',
    templateUrl: './view-source-item.component.html',
    styleUrls: ['./view-source-item.component.css'],
    imports: [NbCardModule, NbIconModule, NbButtonModule]
})
export class ViewSourceItemComponent implements OnInit {
  public sourceItem: SourceItem;
  public type;
  public title;

  constructor(protected ref: NbDialogRef<ViewSourceItemComponent>, public utility: UtilityService) {}

  public ngOnInit() {
    if (this.type === DRBTYPE.FILE) {
      this.title = $localize`Viewing File Source`;
    }
    if (this.type === DRBTYPE.LINK) {
      this.title = $localize`Viewing Link Source`;
    }
    if (this.type === DRBTYPE.VIDEO) {
      this.title = $localize`Viewing Video Source`;
    }
  }

  public close() {
    this.ref.close();
  }

  public titleCaseWord(word: string) {
    if (!word) {
      return word;
    }

    return word[0].toUpperCase() + word.substring(1).toLowerCase();
  }
}
